import React from 'react'
import { Typography, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { trackButtonClick } from '../../../../utils/gtmUtils'
import './WhatIsDailyvents.css'

const { Title, Paragraph } = Typography

interface WhatIsDailyventsProps {
    onGetStarted: () => void
}

const WhatIsDailyvents: React.FC<WhatIsDailyventsProps> = ({
    onGetStarted,
}) => {
    const { t } = useTranslation()

    return (
        <div className="whatis-container">
            <div className="image-group">
                <div className="image">
                    <img
                        className="image-top"
                        src="/img/whatis-Volley.png"
                        alt={t('common.alt.volleyball')}
                    />
                </div>
                <div className="image">
                    <img
                        className="image-bottom"
                        src="/img/whatis-Football.png"
                        alt={t('common.alt.football')}
                    />
                </div>
            </div>
            <div className="text-container">
                <Title className="title" level={2}>
                    {t('home.whatIsDailyvents.title')}
                </Title>
                <Paragraph className="paragraph">
                    {t('home.whatIsDailyvents.description')}
                </Paragraph>
                <Button
                    type="default"
                    size="large"
                    onClick={() => {
                        trackButtonClick('get_started', 'whatis')
                        onGetStarted()
                    }}
                >
                    {t('home.whatIsDailyvents.getStarted')}
                </Button>
            </div>
        </div>
    )
}

export default WhatIsDailyvents
